<div class="banner__section">
  <app-home-banner (scrollToSection)="scrollToEvaluateSkills()" [bannerList]="bannerList"></app-home-banner>
</div>
<!-- sport journey section -->
<section class="common__spacing--between-section supportSection" [ngClass]="userLoggedIn ? 'd-none' : ''">
  <div class="container-fluid">
    <div class="feature-section_heading text-align-center">
      <h2 class="secondary__heading">How we support your journey</h2>
      <p class="content_des">
        At XDGE, we help athletes excel with expert evaluations, personalized scoring, and a supportive community. Track progress,celebrate
        achievements, and connect with sports enthusiasts. Unlock your potential with us!
      </p>
    </div>
    <div class="feature-section">
      <div class="row">
        <div class="col-6 col-sm-4 col-md-4 col-lg-4">
          <div class="feature-card feature-card--01">
            <div class="feature-card__number">01</div>
            <div class="feature-card__title">Unleash Your Potential</div>
            <div class="feature-card__description">
              Reach new heights with expert scores at XDGE. Track progress, celebrate, and stay motivated with community support.
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-4 col-lg-4">
          <div class="feature-card feature-card--02">
            <div class="feature-card__number">02</div>
            <div class="feature-card__title">Discover top XDGE sports gear</div>
            <div class="feature-card__description">
              Explore our store for the latest XDGE sports apparel. Find the gear you need to enhance your performance and achieve your goals.
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-4">
          <div class="feature-card feature-card--03">
            <div class="feature-card__number">03</div>
            <div class="feature-card__title">Stay Updated on Events</div>
            <div class="feature-card__description">
              Track upcoming sports events and opportunities. Join the action, connect with athletes, and make the most of every event.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- sport journey section -->
<section class="common__spacing--between-section featureSection" *ngIf="topSportSequence.length > 0">
  <div class="container-fluid">
    <div class="feature-section_heading full__width guestContainer">
      <div class="guestContent">
        <h2 class="secondary__heading">Top XDGE sports to explore</h2>
        <p class="content_des">Explore a variety of sports and start your journey towards excellence.</p>
      </div>
      <button (click)="viewAll('/sports', 'sports')" class="common--button_unfill border--grey postion__right">View all</button>
    </div>
    <div class="feature-section sport_explore">
      <div class="rows">
        <div class="sport__column" *ngIf="topSportSequence.length > 0">
          <div class="explore-card h-50">
            <img
              [ngSrc]="
                topSportSequence[0].image
                  ? fileDirectoriesPath + topSportSequence[0].image
                  : topSportSequence[0].largeImage
                    ? fileDirectoriesPath + topSportSequence[0].largeImage
                    : 'assets/images/ic_level.svg'
              "
              onerror="this.ngSrc = 'assets/images/ic_level.svg'"
              alt="level image"
              fill
              [ngClass]="topSportSequence[0].image || topSportSequence[0].largeImage ? 'banner-img-cover' : ''"
              [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[0].id : '/'"
              (click)="userLoggedIn ? '' : onExploreClick()"
            />
            <figcaption class="event_info">
              <div class="d-flex align-items-end justify-content-between">
                <div class="content">
                  <h5>{{ topSportSequence[0].name }}</h5>
                  <p [innerHTML]="topSportSequence[0].about || ''"></p>
                </div>
                <a
                  class="explore--button event_tag"
                  [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[0].id : '/'"
                  (click)="userLoggedIn ? '' : onExploreClick()"
                  >Explore more</a
                >
              </div>
            </figcaption>
          </div>
          <div class="explore-card mt-17 h-50" *ngIf="topSportSequence.length > 1">
            <img
              [ngSrc]="
                topSportSequence[1].image
                  ? fileDirectoriesPath + topSportSequence[1].image
                  : topSportSequence[1].largeImage
                    ? fileDirectoriesPath + topSportSequence[1].largeImage
                    : 'assets/images/ic_level.svg'
              "
              onerror="this.ngSrc = 'assets/images/ic_level.svg'"
              alt="level image"
              fill
              [ngClass]="topSportSequence[1].image || topSportSequence[1].largeImage ? 'banner-img-cover' : ''"
              [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[1].id : '/'"
              (click)="userLoggedIn ? '' : onExploreClick()"
            />
            <figcaption class="event_info">
              <div class="d-flex align-items-end justify-content-between">
                <div class="content">
                  <h5>{{ topSportSequence[1].name }}</h5>
                  <p [innerHTML]="topSportSequence[1].about || ''"></p>
                </div>
                <a
                  class="explore--button event_tag"
                  [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[1].id : '/'"
                  (click)="userLoggedIn ? '' : onExploreClick()"
                  >Explore more</a
                >
              </div>
            </figcaption>
          </div>
        </div>
        <div class="sport__column" *ngIf="topSportSequence.length > 2">
          <div class="explore-card">
            <img
              [ngSrc]="
                topSportSequence[2].largeImage
                  ? fileDirectoriesPath + topSportSequence[2].largeImage
                  : topSportSequence[2].image
                    ? fileDirectoriesPath + topSportSequence[2].image
                    : 'assets/images/ic_level.svg'
              "
              onerror="this.ngSrc = 'assets/images/ic_level.svg'"
              alt="level image"
              fill
              [ngClass]="topSportSequence[2].largeImage || topSportSequence[2].image ? 'banner-img-cover' : ''"
              [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[2].id : '/'"
              (click)="userLoggedIn ? '' : onExploreClick()"
            />
            <figcaption class="event_info">
              <div class="d-flex align-items-end justify-content-between">
                <div class="content">
                  <h5>{{ topSportSequence[2].name }}</h5>
                  <p [innerHTML]="topSportSequence[2].about || ''"></p>
                </div>
                <a
                  class="explore--button event_tag"
                  [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[2].id : '/'"
                  (click)="userLoggedIn ? '' : onExploreClick()"
                  >Explore more</a
                >
              </div>
            </figcaption>
          </div>
        </div>
        <div class="sport__column">
          <div class="explore-card h-50">
            <img
              [ngSrc]="
                topSportSequence[3].image
                  ? fileDirectoriesPath + topSportSequence[3].image
                  : topSportSequence[3].largeImage
                    ? fileDirectoriesPath + topSportSequence[3].largeImage
                    : 'assets/images/ic_level.svg'
              "
              onerror="this.ngSrc = 'assets/images/ic_level.svg'"
              alt="level image"
              fill
              [ngClass]="topSportSequence[3].image || topSportSequence[3].largeImage ? 'banner-img-cover' : ''"
              [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[3].id : '/'"
              (click)="userLoggedIn ? '' : onExploreClick()"
            />
            <figcaption class="event_info">
              <div class="d-flex align-items-end justify-content-between">
                <div class="content">
                  <h5>{{ topSportSequence[3].name }}</h5>
                  <p [innerHTML]="topSportSequence[3].about || ''"></p>
                </div>
                <a
                  class="explore--button event_tag"
                  [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[3].id : '/'"
                  (click)="userLoggedIn ? '' : onExploreClick()"
                  >Explore more</a
                >
              </div>
            </figcaption>
          </div>
          <div class="explore-card mt-17 h-50">
            <img
              [ngSrc]="
                topSportSequence[4].image
                  ? fileDirectoriesPath + topSportSequence[4].image
                  : topSportSequence[4].largeImage
                    ? fileDirectoriesPath + topSportSequence[4].largeImage
                    : 'assets/images/ic_level.svg'
              "
              onerror="this.ngSrc = 'assets/images/ic_level.svg'"
              alt="level image"
              fill
              [ngClass]="topSportSequence[4].image || topSportSequence[4].largeImage ? 'banner-img-cover' : ''"
              [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[4].id : '/'"
              (click)="userLoggedIn ? '' : onExploreClick()"
            />
            <figcaption class="event_info">
              <div class="d-flex align-items-end justify-content-between">
                <div class="content">
                  <h5>{{ topSportSequence[4].name }}</h5>
                  <p [innerHTML]="topSportSequence[4].about || ''"></p>
                </div>
                <a
                  class="explore--button event_tag"
                  [routerLink]="userLoggedIn ? '/sports/' + topSportSequence[4].id : '/'"
                  (click)="userLoggedIn ? '' : onExploreClick()"
                  >Explore more</a
                >
              </div>
            </figcaption>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- common section -->
<section
  #evaluateSkillsSection
  id="evaluateSkillsSection"
  class="evaluateSkill common__spacing--between-section grey__background"
  [ngClass]="userLoggedIn ? 'd-none' : ''"
>
  <ng-template #childContainer> </ng-template>
</section>
<!-- <app-evaluate-skills #evaluateSkillsSection id="evaluateSkillsSection" [ngClass]="userLoggedIn ? 'd-none' : ''"></app-evaluate-skills> -->
<!-- feed section -->
<ng-container *ngIf="userLoggedIn && expertUser">
  <section class="pendingFeeds common__spacing--between-section grey__background" [hidden]="feedList == 0">
    <div class="container-fluid">
      <div class="feed-sec">
        <div class="feature-section_heading full__width guestContainer">
          <div class="guestContent">
            <h2 class="secondary__heading">Pending feeds for your review</h2>
            <p class="content_des">Shape the Rankings! Add Your Scores to the Feeds That Need Your ExpertJudgment</p>
          </div>
          <a routerLink="/feed/review" *ngIf="feedList > 3" class="common--button_unfill border--grey postion__right">View all</a>
        </div>
        <app-featured-feed [usedFor]="'PendingReview'" (feeds)="feedList = $event"></app-featured-feed>
      </div>
    </div>
  </section>
</ng-container>

<!-- UPCOMInG section -->
<section class="upEvents common__spacing--between-section" [hidden]="eventList == 0">
  <div class="container-fluid">
    <div class="feature-section_heading full__width guestContainer">
      <div class="guestContent">
        <h2 class="secondary__heading">
          <!-- Stay updated on upcoming events -->
          Discover 1,000+ Events That Will Transform Your Experience
        </h2>
        <!-- <p class="content_des">
          Never miss a moment! Keep track of upcoming sports events
        </p> -->
      </div>
      <button (click)="viewAll('/events/eventByOthers', 'event')" *ngIf="eventList > 3" class="common--button_unfill border--grey postion__right">
        View all
      </button>
    </div>
    <!-- common event list -->
    <div class="home_event">
      <app-common-event-list (events)="eventList = $event" [Upcomming]="true"></app-common-event-list>
    </div>
  </div>
</section>
<!-- featured feed -->
<ng-container *ngIf="userLoggedIn && expertUser">
  <section class="featFeed common__spacing--between-section grey__background" [hidden]="featuredFeedList == 0">
    <div class="container-fluid">
      <div class="feed-sec">
        <div class="feature-section_heading full__width guestContainer">
          <div class="guestContent">
            <h2 class="secondary__heading">Featured feed</h2>
            <p class="content_des">Discover top-scored feeds—standout performances that will impress and inspire!</p>
          </div>
          <button (click)="viewAll('/featureFeed', 'feed')" *ngIf="featuredFeedList > 3" class="common--button_unfill border--grey postion__right">
            View all
          </button>
        </div>
        <app-featured-feed [usedFor]="'home'" (feeds)="featuredFeedList = $event"></app-featured-feed>
      </div>
    </div>
  </section>
</ng-container>
<!-- xdge store section -->
<section class="topGear common__spacing--between-section" [hidden]="xdgeStoreList.length == 0">
  <div class="container-fluid">
    <div class="feature-section_heading full__width guestContainer">
      <div class="guestContent">
        <h2 class="secondary__heading">Discover top XDGE sports gear</h2>
        <p class="content_des">Shop exclusive sports gear and limited-edition apparel for extreme sports enthusiasts.</p>
      </div>
      <button (click)="viewAll('/store', '')" *ngIf="xdgeStoreList.length > 3" class="common--button_unfill border--grey postion__right">
        View all
      </button>
    </div>
    <app-common-xdge-store (xdge)="xdgeStoreList = $event" [withToken]="false"></app-common-xdge-store>
  </div>
</section>

<!-- ads -->
<!-- <section class="common__spacing--between-section grey__background adshome" *ngIf="userLoggedIn && expertUser">
  <div class="container-fluid">
    <app-ads></app-ads>
  </div>
</section> -->

<!-- News section -->
<section class="latUpdates common__spacing--between-section" *ngIf="userLoggedIn" [hidden]="xdgeNewsList == 0">
  <div class="container-fluid">
    <div class="feature-section_heading full__width guestContainer">
      <div class="guestContent">
        <h2 class="secondary__heading">Latest news & updates</h2>
        <p class="content_des">Stay on top of the game with the most recent developments in the world of sports.</p>
      </div>
      <button (click)="viewAll('/media', '')" *ngIf="xdgeNewsList > 3" class="common--button_unfill border--grey postion__right">View all</button>
    </div>
    <app-common-news (xdge)="xdgeNewsList = $event" [usedFor]="'home'"></app-common-news>
  </div>
</section>
<app-tab-to-top></app-tab-to-top>
